export default __webpack_public_path__ + "static/media/Recruit's Strength.480917e2.jpg";